<div class='mat-form-field'>
  <div class='mat-form-field-wrapper'>
    <div class='mat-form-field-flex'>
      <div class='mat-form-field-infix'>
        <label for='pageCount'>Items per page.</label>
        <mat-select name="pageCount" #pageCount>
          <mat-option value="10">10</mat-option>
          <mat-option value="20">20</mat-option>
          <mat-option value="50">50</mat-option>
          <mat-option value="100">100</mat-option>
        </mat-select>
      </div>
    </div>
  </div>
</div>
